import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let PaymentController = {
    getList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/payment/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    }
}

export default PaymentController
